class RegionSwitch {
	constructor(wrapper) {
		this.wrapper = wrapper;
		this.button = undefined;
		this.dropdown = undefined;
		this.dropdownAnchors = undefined;
		this.dropdownItems = undefined;
		this.buttonLabel = undefined;
		this.buttonLabelSelect = undefined;
		this.regionLinks = {};
		this.timeout = undefined;

		this.state = {
			isOpen: false
		};

		if (this.wrapper) {
			this.initRegionSwitch();
		}
	}

	initRegionSwitch() {
		this.button = this.wrapper.querySelector('.js-region-switcher__button');
		this.dropdown = this.wrapper.querySelector('.js-region-switcher__dropdown');
		this.dropdownAnchors = this.dropdown.querySelectorAll('a');
		this.dropdownItems = this.dropdown.querySelectorAll('.c-region-switcher__dropdown-item-button');
		this.buttonLabel = this.button.querySelector('.region-label');
		this.buttonLabelSelect = this.button.querySelector('.region-label-select');
		/* eslint-disable */
		this.rootDomain = window.location.origin + '/';

		const regionLinks = document.querySelectorAll('link[rel="alternate"][hreflang]');
		[...regionLinks].forEach((regionLink) => {
			const hreflang = regionLink.getAttribute('hreflang');
			const href = regionLink.getAttribute('href');
			this.regionLinks = { ...this.regionLinks, [hreflang]: href };
		});

		[...this.dropdownAnchors].forEach((element) => {
			const anchor = element;
			const hreflang = element.dataset.region;
			const homePage = this.rootDomain + hreflang + '/';
			anchor.href = this.regionLinks[hreflang] || homePage;
		});
		/* eslint-enable */
		// const link = document.querySelector('link[rel="alternate"][hreflang]');

		this.wrapper.addEventListener('click', this.handleWrapperClick.bind(this));
		this.wrapper.addEventListener('mouseenter', this.openDropdown.bind(this));
		this.wrapper.addEventListener('mouseleave', () => {
			this.timeout = setTimeout(() => {
				this.closeDropdown();
			}, 500);
		});
	}

	handleWrapperClick(event) {
		if (event.target === this.button) {
			this.toggleDropdown();
		} else if (event.target.classList.contains('c-region-switcher__dropdown-item-button')) {
			this.handleDropdownClick(event);
		}
	}

	toggleDropdown() {
		if (!this.state.isOpen) {
			this.openDropdown();
		} else {
			this.closeDropdown();
		}
	}

	openDropdown() {
		clearTimeout(this.timeout);
		this.state.isOpen = true;
		this.dropdown.classList.remove('hide');
		this.button.setAttribute('aria-expanded', true);
		if (this.buttonLabel) {
			this.buttonLabel.classList.add('hide');
			this.buttonLabelSelect.classList.remove('hide');
		}
	}

	closeDropdown() {
		this.state.isOpen = false;
		this.dropdown.classList.add('hide');
		if (this.buttonLabel) {
			this.buttonLabel.classList.remove('hide');
			this.buttonLabelSelect.classList.add('hide');
		}
		this.button.removeAttribute('aria-expanded');
	}

	handleDropdownClick(event) {
		if (event.target.dataset.region) {
			this.toggleDropdown();
		}
	}

	// TODO: implement full keyboard navigation
	handleKeyboard(handle, event) {
		const { key } = event;

		if (handle === 'open') {
			if (key === 'ArrowDown') {
				this.openDropdown();
				this.dropdownItems[0].focus();
			} else if (key === 'ArrowUp') {
				this.openDropdown();
				this.dropdownItems[this.dropdownItems.length - 1].focus();
			}
		} else if (handle === 'navigation') {
			// TODO: complete keyboard navigation: allow optional chaining and tab selects next
			// focusable element

			// if (key === 'ArrowUp') {
			// 	console.log('U', document.activeElement.parentElement?.previousElementSibling);
			// 	const previousElement = document.activeElement.parentElement?.previousElementSibling;
			// 	previousElement ? previousElement.focus() : this.button.focus();
			// } else if (key === 'ArrowDown') {
			// 	console.log('D', document.activeElement.parentElement?.nextElementSibling);
			// 	const nextElement = document.activeElement.parentElement?.nextElementSibling;
			// 	nextElement ? nextElement.focus() : this.button.focus();
			// } else if (key === 'Escape') {
			// 	this.closeDropdown();
			// }
		}
	}
}

export default RegionSwitch;
